import { Select, SelectContent, SelectItem, SelectTrigger } from "@/components/ui/select";
import { Variable } from "@/components/InputVariableConfigurator/types";

const NONE_VALUE = "__none__";

export const InputVariableSelect = ({
  vars,
  onChange,
  selected,
  defaultMessage,
}: {
  vars: Variable[];
  onChange: (key: string | null) => void;
  selected?: Variable | undefined;
  defaultMessage: string;
}) => {
  const handleValueChange = (value: string) => {
    onChange(value === NONE_VALUE ? null : value);
  };

  return (
    <Select value={selected?.key ?? NONE_VALUE} onValueChange={handleValueChange}>
      <SelectTrigger className="truncate whitespace-nowrap">
        {selected?.key ?? <span className="text-muted-foreground">{defaultMessage}</span>}
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={NONE_VALUE} className="text-muted-foreground">
          {defaultMessage}
        </SelectItem>
        {vars?.map(variable => (
          <SelectItem key={variable.key} value={variable.key}>
            {variable.key}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
